import { BadgeEuro } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

export function PriceOrDiscountBlock({
  label,
  value,
  compareAt,
  helper,
  bare = false,
  className,
}: {
  /** Optional caption row (icon + text). Omit for a bare, compact price. */
  label?: string
  value: string
  /** Optional previous / unsubsidized amount shown struck through beside the final price. */
  compareAt?: string
  helper?: string
  /** No box (border/bg/padding), right-aligned. Use when the price sits beside the CTA. */
  bare?: boolean
  className?: string
}) {
  return (
    <div className={cn(bare ? 'text-right' : 'rounded-lg border border-border bg-background px-3 py-2', className)}>
      {label ? (
        <div className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
          <BadgeEuro className="size-4 shrink-0" aria-hidden />
          <span>{label}</span>
        </div>
      ) : null}
      <div
        className={cn(
          'flex flex-wrap items-baseline justify-end gap-x-2 text-lg font-semibold leading-tight text-foreground',
          label ? 'mt-1' : undefined,
          bare ? undefined : 'justify-start',
        )}
      >
        {compareAt ? (
          <span className="text-sm font-normal text-muted-foreground line-through">{compareAt}</span>
        ) : null}
        <span>{value}</span>
      </div>
      {helper ? (
        <div className="mt-1 break-words text-xs leading-snug text-muted-foreground">{helper}</div>
      ) : null}
    </div>
  )
}
